(() => {
'use strict';
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
const money = c => '£' + (c % 100 === 0 ? c / 100 : (c / 100).toFixed(2));
window.dataLayer = window.dataLayer || [];
const track = (event, p = {}) => window.dataLayer.push({ event, ...p, t: Date.now() });
let tt; function toast(m) { const t = $('#toast'); t.textContent = m; t.classList.add('show'); clearTimeout(tt); tt = setTimeout(() => t.classList.remove('show'), 3400); }
const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
let storyTo = null;
const hdr = $('#hdr');
const view = () => document.body.classList.contains('t-product') ? 'product' : 'home';

/* ---------- navigation ---------- */
function go(id, smooth = true) {
  const el = document.getElementById(id); if (!el) return false;
  if (id === 'vessels' && storyTo) { requestAnimationFrame(() => storyTo(1, smooth)); return true; }
  requestAnimationFrame(() => el.scrollIntoView({ behavior: smooth && !RM ? 'smooth' : 'auto', block: 'start' }));
  return true;
}
document.addEventListener('click', e => {
  const a = e.target.closest('a[href]'); if (!a) return;
  const u = new URL(a.href, location.href);
  if (u.origin === location.origin && u.pathname === location.pathname && u.hash.length > 1) {
    if (go(u.hash.slice(1))) { e.preventDefault(); closeMenu(); try { history.replaceState(null, '', u.hash); } catch (err) {} }
  }
  if (a.dataset.track) track(a.dataset.track);
});
addEventListener('scroll', () => hdr.classList.toggle('s', scrollY > 10), { passive: true });
const mm = $('#mm'), mb = $('#menuBtn');
function openMenu() { mm.hidden = false; mb.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; $('#menuClose').focus(); }
function closeMenu() { if (mm.hidden) return; mm.hidden = true; mb.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; }
mb.addEventListener('click', openMenu); $('#menuClose').addEventListener('click', () => { closeMenu(); mb.focus(); });
mm.addEventListener('click', e => { if (e.target.closest('a')) closeMenu(); });

/* ---------- bag: Shopify's own cart ---------- */
let cart = null;
const FREE = NAC.free;
const thumb = h => (NAC.thumbs && NAC.thumbs[h]) || '';
async function loadCart() { try { cart = await (await fetch(NAC.cart + '.js', { headers: { Accept: 'application/json' } })).json(); } catch (e) {} renderBag(); }
function renderBag() {
  if (!cart) return;
  const n = cart.item_count, b = $('.bag-n'); b.textContent = n; b.dataset.n = n; $('#bagBtn').setAttribute('aria-label', `Open bag, ${n} item${n === 1 ? '' : 's'}`);
  const body = $('#dBody'), foot = $('#dFoot');
  if (!cart.items.length) { body.innerHTML = `<div class="empty"><p>Your bag is empty.</p><a class="btn" href="${NAC.original}">Shop the Original</a></div>`; foot.innerHTML = ''; return; }
  const t = cart.items_subtotal_price, left = Math.max(0, FREE - t);
  body.innerHTML = `<div class="meter"><span>${left ? `${money(left)} from complimentary delivery` : 'Complimentary UK delivery'}</span><div class="t"><i style="--p:${Math.min(100, t / FREE * 100)}%"></i></div></div>` +
    cart.items.map((l, i) => {
      const props = l.properties || {}, gift = props['Gift box'], note = props['Gift note'];
      const img = thumb(l.handle) || (l.image || '');
      return `<div class="line" data-key="${esc(l.key)}"><img src="${esc(img)}" alt="" width="84" height="105">
      <div class="l1"><b>${esc(l.product_title)}</b>${gift ? `<span class="note">${note ? '“' + esc(note) + '”' : 'In the gift box'}</span>` : ''}<button class="rm" type="button" data-rm>Remove</button></div>
      <div class="l2"><span class="num">${money(l.final_line_price)}</span><div class="qty" role="group" aria-label="Quantity"><button type="button" data-lq="-1" aria-label="Decrease">−</button><output>${l.quantity}</output><button type="button" data-lq="1" aria-label="Increase">+</button></div></div></div>`;
    }).join('');
  foot.innerHTML = `<div class="d-t"><span class="cap">Subtotal</span><span class="num">${money(t)}</span></div><small>Taxes included. Delivery calculated at checkout.</small>
    <a class="btn btn-wide" href="/checkout" data-co>Checkout</a>`;
}
async function change(key, q) {
  try { cart = await (await fetch(NAC.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) })).json(); renderBag(); } catch (e) { toast('Something went wrong. Please try again.'); }
}
$('#drawer').addEventListener('click', e => {
  const ln = e.target.closest('.line'); if (!ln) { if (e.target.closest('[data-co]')) track('begin_checkout', { value: cart && cart.total_price / 100, currency: 'GBP' }); return; }
  const key = ln.dataset.key, l = cart.items.find(x => x.key === key); if (!l) return;
  if (e.target.closest('[data-lq]')) change(key, Math.max(0, l.quantity + +e.target.closest('[data-lq]').dataset.lq));
  else if (e.target.closest('[data-rm]')) { change(key, 0); track('remove_from_cart', { item_id: l.handle }); }
});
let lastF;
function openBag() { lastF = document.activeElement; $('#drawer').classList.add('open'); $('#scrim').classList.add('open'); $('#drawer').setAttribute('aria-hidden', 'false'); $('#drawer').setAttribute('role', 'dialog'); $('#drawer').setAttribute('aria-modal', 'true'); setTimeout(() => $('#drawerClose').focus(), 80); }
function closeBag() { $('#drawer').classList.remove('open'); $('#scrim').classList.remove('open'); $('#drawer').setAttribute('aria-hidden', 'true'); lastF && lastF.focus && lastF.focus(); }
$('#bagBtn').addEventListener('click', async () => { await loadCart(); openBag(); track('view_cart'); });
$('#drawerClose').addEventListener('click', closeBag); $('#scrim').addEventListener('click', closeBag);
document.addEventListener('keydown', e => {
  if (e.key === 'Escape') { if ($('#drawer').classList.contains('open')) closeBag(); closeMenu(); }
  if (e.key === 'Tab' && $('#drawer').classList.contains('open')) { const f = $$('#drawer button, #drawer a[href]').filter(x => x.offsetParent); if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); } else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); } }
});
async function addToCart(fd, src) {
  const r = await fetch(NAC.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
  if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error(j.description || j.message || 'Could not add to bag'); }
  await loadCart(); const b = $('.bag-n'); b.classList.remove('pop'); void b.offsetWidth; b.classList.add('pop');
  track('add_to_cart', { source: src, currency: 'GBP' }); openBag();
}
document.addEventListener('click', async e => {
  const a = e.target.closest('[data-add]'); if (!a || a.disabled) return;
  a.disabled = true;
  try { const fd = new FormData(); fd.append('id', a.dataset.add); fd.append('quantity', 1); await addToCart(fd, 'collection'); } catch (err) { toast(err.message); }
  a.disabled = false;
});

/* ---------- buy panel ---------- */
const f = $('#buy');
if (f) {
  let q = 1; const out = $('#q'), ap = $('[data-ap]', f), unit = ap ? +ap.dataset.unit : 0;
  const sync = () => { out.textContent = q; if (ap) ap.textContent = money(unit * q); };
  f.addEventListener('click', e => { const b = e.target.closest('[data-q]'); if (b) { q = clamp(q + +b.dataset.q, 1, 20); sync(); } });
  f.addEventListener('change', e => { if (e.target.id === 'gift') { $('[data-gx]', f).hidden = !e.target.checked; track('gift_toggle', { on: e.target.checked }); } });
  f.addEventListener('input', e => { if (e.target.id === 'note') $('[data-cnt]', f).textContent = `${e.target.value.length}/180`; });
  f.addEventListener('submit', async e => {
    e.preventDefault(); const btn = $('[data-atc]', f); if (btn.disabled) return; btn.disabled = true;
    const fd = new FormData(f); fd.set('quantity', q);
    if (!$('#gift', f).checked) { fd.delete('properties[Gift box]'); fd.delete('properties[Gift note]'); } else if (!String(fd.get('properties[Gift note]') || '').trim()) fd.delete('properties[Gift note]');
    try { await addToCart(fd, 'pdp'); $('#buyMsg').textContent = ''; } catch (err) { $('#buyMsg').classList.add('err'); $('#buyMsg').textContent = err.message; }
    btn.disabled = false;
  });
  if (new URLSearchParams(location.search).get('gift')) { const c = $('#gift', f); c.checked = true; $('[data-gx]', f).hidden = false; }
  new IntersectionObserver(es => { if (es[0].isIntersecting) track('view_item'); }).observe(f);
}

/* ---------- enquiry ---------- */
const dlg = $('#enq');
document.addEventListener('click', e => { if (e.target.closest('[data-enq]')) { dlg.showModal ? dlg.showModal() : dlg.setAttribute('open', ''); $('#eName').focus(); track('enquiry_open'); } });
$('#enqClose').addEventListener('click', () => dlg.close());

/* ---------- motion ---------- */
const rio = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.remove('wait'); rio.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' });
$$('.rise').forEach(el => { if (!RM && el.getBoundingClientRect().top > innerHeight) { el.classList.add('wait'); rio.observe(el); } });

/* ---------- live 3D tube (built from the print artwork) ---------- */
function viewer(host, opts = {}) {
  if (!window.THREE || !host) return null;
  const T = window.THREE;
  let gl; try { gl = new T.WebGLRenderer({ antialias: true, alpha: true, powerPreference: 'high-performance' }); } catch (e) { return null; }
  gl.setPixelRatio(Math.min(2, window.devicePixelRatio || 1));
  gl.outputEncoding = T.sRGBEncoding; gl.physicallyCorrectLights = true;
  gl.shadowMap.enabled = true; gl.shadowMap.type = T.PCFSoftShadowMap;
  host.appendChild(gl.domElement);
  const scene = new T.Scene();
  const cam = new T.PerspectiveCamera(opts.fov || 19, 1, 0.01, 10);
  // soft studio environment for reflections
  const pm = new T.PMREMGenerator(gl); const room = new T.Scene();
  room.add(new T.Mesh(new T.BoxGeometry(6, 6, 6), new T.MeshBasicMaterial({ color: 0x9a968f, side: T.BackSide })));
  [[-2, 2, 1, 3], [2, 1.5, -1, 1.5], [0, 2.9, 0, 2.2]].forEach(([x, y, z, s]) => { const p = new T.Mesh(new T.PlaneGeometry(s, s), new T.MeshBasicMaterial({ color: 0xffffff })); p.position.set(x, y, z); p.lookAt(0, 0, 0); room.add(p); });
  scene.environment = pm.fromScene(room, 0.04).texture;
  const K = opts.k || 1.55; const key = new T.DirectionalLight(0xffffff, 1.15 * K); key.position.set(-0.55, 0.95, 0.65); key.castShadow = true;
  key.shadow.mapSize.set(2048, 2048); key.shadow.camera.left = key.shadow.camera.bottom = -0.35; key.shadow.camera.right = key.shadow.camera.top = 0.35; key.shadow.camera.near = 0.2; key.shadow.camera.far = 3; key.shadow.radius = 8; key.shadow.bias = -0.0006; key.target.position.set(0, 0.08, 0); scene.add(key.target);
  scene.add(key); scene.add(new T.HemisphereLight(0xffffff, 0xe9e3da, 0.55 * K));
  const rim = new T.DirectionalLight(0xfff4ea, 0.35 * K); rim.position.set(0.6, 0.6, -0.8); scene.add(rim);
  const ground = new T.Mesh(new T.PlaneGeometry(2, 2), new T.ShadowMaterial({ opacity: 0.13 })); ground.rotation.x = -Math.PI / 2; ground.receiveShadow = true; scene.add(ground);

  const R = 0.0495, H = 0.175, SEAM = 0.705, BH = H * (1 - SEAM), FRONT = 0.72, TS = -2 * Math.PI * FRONT;
  let ready = false; const L = new T.TextureLoader(); const aniso = gl.capabilities.getMaxAnisotropy();
  const tex = (u) => { const clones = []; const t = L.load(u, () => { clones.forEach(c => { c.image = t.image; c.needsUpdate = true; }); draw(); }); t.encoding = T.sRGBEncoding; t.anisotropy = aniso; t._clones = clones; return t; };
  const wrap = tex(NAC.media['t-wrap']), top = tex(NAC.media['t-top']), bot = tex(NAC.media['t-bottom']), slv = tex(NAC.media['t-sleeve']);
  const paper = map => new T.MeshPhysicalMaterial({ map, roughness: 0.55, clearcoat: 0.12, clearcoatRoughness: 0.5, envMapIntensity: 0.35 });
  const card = new T.MeshStandardMaterial({ color: 0xd4e6e2, roughness: 0.9 });
  const band = (r, y0, y1, t, rx, ox, ry, oy) => {
    const tt = t.clone(); t._clones.push(tt); tt.wrapS = tt.wrapT = T.RepeatWrapping; tt.repeat.set(rx, ry); tt.offset.set(ox, oy); if (t.image && t.image.complete) tt.needsUpdate = true;
    const g = new T.Group();
    const outer = new T.Mesh(new T.CylinderGeometry(r, r, y1 - y0, 192, 1, true, TS, Math.PI * 2), paper(tt)); outer.position.y = (y0 + y1) / 2; outer.castShadow = true; g.add(outer);
    const inner = new T.Mesh(new T.CylinderGeometry(r - 0.0012, r - 0.0012, y1 - y0, 96, 1, true), card); inner.material.side = T.BackSide; inner.position.y = outer.position.y; g.add(inner);
    const lip = new T.Mesh(new T.RingGeometry(r - 0.0012, r, 96), new T.MeshStandardMaterial({ color: 0xcfc8bb, roughness: 0.9, side: T.DoubleSide })); lip.rotation.x = -Math.PI / 2; lip.position.y = y1; g.add(lip);
    const lip2 = lip.clone(); lip2.position.y = y0; g.add(lip2);
    return g;
  };
  const tube = new T.Group(); scene.add(tube);
  tube.add(band(R, 0.0006, BH, wrap, 1, 0, 1 - SEAM, 0));
  const sleeve = band(R - 0.0016, 0.004, H - 0.01, slv, 1.21, -0.06, 1.15, -0.02); tube.add(sleeve);
  const bottom = new T.Mesh(new T.CircleGeometry(R, 128), paper(bot)); bottom.rotation.x = Math.PI / 2; bottom.position.y = 0.0004; tube.add(bottom);
  // candle pearls at the mouth of the sleeve: minute white pearls (~1.1 mm), packed
  const pc = document.createElement('canvas'); pc.width = pc.height = 512; const px = pc.getContext('2d');
  px.fillStyle = '#d9d8d3'; px.fillRect(0, 0, 512, 512);
  const sp = document.createElement('canvas'); sp.width = sp.height = 16; const sx = sp.getContext('2d');
  const sg = sx.createRadialGradient(6, 6, 0.6, 8, 8, 8); sg.addColorStop(0, '#ffffff'); sg.addColorStop(0.55, '#f1f0ec'); sg.addColorStop(0.9, '#d6d4ce'); sg.addColorStop(1, 'rgba(200,198,192,0)');
  sx.fillStyle = sg; sx.beginPath(); sx.arc(8, 8, 8, 0, 6.283); sx.fill();
  for (let i = 0; i < 12000; i++) { const d = 5 + Math.random() * 2; px.drawImage(sp, Math.random() * 512 - d / 2, Math.random() * 512 - d / 2, d, d); }
  const pt = new T.CanvasTexture(pc); pt.encoding = T.sRGBEncoding; pt.anisotropy = aniso;
  const pearls = new T.Mesh(new T.CircleGeometry(R - 0.003, 96), new T.MeshStandardMaterial({ map: pt, roughness: 0.6 })); pearls.rotation.x = -Math.PI / 2; pearls.position.y = H - 0.016; tube.add(pearls);
  const lid = new T.Group(); tube.add(lid);
  lid.add(band(R, BH + 0.0003, H, wrap, 1, 0, SEAM, 1 - SEAM));
  const cap = new T.Mesh(new T.CircleGeometry(R, 128), paper(top)); cap.rotation.x = -Math.PI / 2; cap.position.y = H + 0.0002; cap.castShadow = true; lid.add(cap);

  const target = new T.Vector3(0, opts.lookY || 0.1, 0); ready = true;
  let spin = !RM, angle = -0.25, vel = 0, drag = false, lx = 0, lift = 0, liftTo = 0, visible = false, raf = null;
  let baseD = 0.9; const baseY = target.y;
  function frame() { const d = baseD * (1 + 0.42 * lift), y = baseY + 0.075 * lift; cam.position.set(0, y + 0.1, d); cam.lookAt(0, y, 0); }
  function size() { const w = host.clientWidth, h = host.clientHeight; if (!w || !h) return; gl.setSize(w, h, false); cam.aspect = w / h; baseD = (opts.dist || 0.8) * (w < h ? 1.15 : 1); cam.updateProjectionMatrix(); draw(); }
  function draw() {
    if (!ready) return;
    frame(); tube.rotation.y = angle; lid.position.y = lift * 0.15; lid.rotation.x = -lift * 0.14; lid.position.z = lift * 0.012;
    gl.render(scene, cam);
    const fb = host.querySelector('.fallback'); if (fb && wrap.image) fb.style.display = 'none';
  }
  function loop(t) {
    raf = null; if (!visible) return;
    if (!drag) { vel *= 0.94; angle += vel; if (spin && Math.abs(vel) < 0.002) angle += 0.0035; }
    lift += (liftTo - lift) * 0.08;
    draw();
    if (!RM || drag || Math.abs(liftTo - lift) > 0.001) raf = requestAnimationFrame(loop);
  }
  const kick = () => { if (visible && !raf) raf = requestAnimationFrame(loop); };
  host.addEventListener('pointerdown', e => { drag = true; lx = e.clientX; vel = 0; host.setPointerCapture(e.pointerId); kick(); track('viewer_drag'); });
  host.addEventListener('pointermove', e => { if (!drag) return; const dx = (e.clientX - lx) / host.clientWidth * 5; angle += dx; vel = dx * 0.6; lx = e.clientX; });
  const up = () => { drag = false; kick(); };
  host.addEventListener('pointerup', up); host.addEventListener('pointercancel', up);
  new ResizeObserver(size).observe(host);
  new IntersectionObserver(es => { visible = es[0].isIntersecting; if (visible) { size(); kick(); } }).observe(host);
  size();
  return { toggleLid() { liftTo = liftTo ? 0 : 1; kick(); return !!liftTo; }, toggleSpin() { spin = !spin; kick(); return spin; } };
}
function bootViewers() { viewer($('#viewer2'), { dist: 0.92, lookY: 0.092, fov: 17 }); }
let threeP = null, viewersBooted = false;
function loadThree() {
  return threeP || (threeP = new Promise((res, rej) => {
    if (window.THREE) return res();
    const sc = document.createElement('script'); sc.src = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
    sc.onload = res; sc.onerror = rej; document.head.appendChild(sc);
  }));
}
function bootViewersOnce() { if (!document.getElementById('viewer2')) return; if (viewersBooted) return; loadThree().then(() => { if (!viewersBooted) { viewersBooted = true; bootViewers(); } }).catch(() => {}); }

/* ---------- films: each plays the cut made for the layout it is shown in, and changes cut if the layout changes
   (the choice used to be made once at load, so a page opened narrow and then widened kept the phone crop) ---------- */
const NARROW = matchMedia('(max-width: 900px)');
const onLayout = fn => (NARROW.addEventListener ? NARROW.addEventListener('change', fn) : NARROW.addListener(fn));
function film(el, v) {                // el carries data-film (wide cut), data-film-m (phone cut) and, optionally, data-qhd
  const pick = () => NARROW.matches ? el.dataset.filmM
    : ((el.dataset.filmQhd && innerWidth * (devicePixelRatio || 1) > 2100) ? el.dataset.filmQhd : el.dataset.filmD);
  const load = () => { const s = pick(); if (v.getAttribute('src') === s) return false; v.preload = 'auto'; v.src = s; return true; };
  onLayout(() => {
    if (!v.getAttribute('src')) return;
    const t = v.currentTime, was = !v.paused;
    v.classList.remove('on');                                           // the poster covers the change
    if (load()) v.addEventListener('loadedmetadata', () => { try { v.currentTime = t % (v.duration || 1); } catch (e) {} if (was) v.play().catch(() => {}); }, { once: true });
  });
  return { load };
}

/* ---------- hero film: nothing on screen but the film ---------- */
(() => {
  const hero = $('#home'), v = $('#heroVideo'), btn = $('#heroToggle'); if (!hero || !v) return;
  const f = film(hero, v);
  let paused = RM;
  const say = () => { const t = paused ? 'Play the film' : 'Pause the film'; btn.textContent = t; btn.setAttribute('aria-label', t); };
  const start = () => { f.load(); v.play().catch(() => {}); };
  v.addEventListener('playing', () => v.classList.add('on'));
  say();
  const kick = () => { if (!paused) start(); };
  if (document.readyState === 'complete') kick(); else addEventListener('load', kick, { once: true });
  btn.addEventListener('click', () => { paused = !paused; paused ? v.pause() : start(); say(); track('video_toggle', { where: 'hero', paused }); });
  new IntersectionObserver(es => { if (!v.getAttribute('src')) return; es[0].isIntersecting && !paused ? v.play().catch(() => {}) : v.pause(); }).observe(v);
})();

/* ---------- any vessel: the film ---------- */
(() => {
  const box = $('#vfilm'); if (!box) return;
  const v = $('#vfVideo'), btn = $('#vfToggle');
                                // the still holds the place until the film is in
  const f = film(box, v);
  const PLAY = '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M7 4.5v15l12-7.5z"/></svg>';
  const PAUSE = '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M7 5h3v14H7zM14 5h3v14h-3z"/></svg>';
  // the control stays out of sight while the film plays (it shows on hover or keyboard focus), and appears only when the film is stopped
  const icon = on => { btn.innerHTML = on ? PAUSE : PLAY; btn.setAttribute('aria-label', on ? 'Pause film' : 'Play film'); btn.toggleAttribute('data-show', !on); };
  let paused = RM;
  btn.hidden = false; icon(false); if (!paused) btn.removeAttribute('data-show');
  const play = () => { f.load(); v.play().then(() => icon(true)).catch(() => icon(false)); };
  v.addEventListener('playing', () => v.classList.add('on'));
  btn.addEventListener('click', () => { if (v.paused) { paused = false; play(); track('video_play', { where: 'vessels' }); } else { paused = true; v.pause(); icon(false); } });
  // the film waits for the page itself to finish loading, then fetches once it is within a screen or so of view
  const arm = () => {
    new IntersectionObserver(es => { if (es[0].isIntersecting && !paused) f.load(); }, { rootMargin: '900px 0px' }).observe(box);
    new IntersectionObserver(es => { if (es[0].isIntersecting) { if (!paused) play(); } else if (!v.paused) v.pause(); }, { threshold: 0.25 }).observe(v);
  };
  if (document.readyState === 'complete') arm(); else addEventListener('load', arm, { once: true });
})();

/* ---------- the story: scent, then the vessel, then the box, in one place. Each text fades as you scroll and the next appears;
   the sand ground gives way to the page's chalk as it goes, so it runs straight on into the film ---------- */
(() => {
  const st = $('.story'); if (!st) return;
  const pin = $('.story-pin', st), panels = $$('.story-panel', st);
  const rmq = matchMedia('(prefers-reduced-motion: reduce)'), shortq = matchMedia('(max-height: 520px)');
  const WIN = [[-1, -1, .26, .36], [.31, .41, .60, .70], [.65, .75, 2, 2]];   // each text's window on the scroll: in from a to b, out from c to d
  const SAND = [242, 237, 230], CHALK = [251, 250, 247];
  const sm = t => t <= 0 ? 0 : t >= 1 ? 1 : t * t * (3 - 2 * t);
  let live = false, raf = 0;
  const hdrH = () => Math.round(hdr.getBoundingClientRect().height);
  const top = () => st.getBoundingClientRect().top + scrollY;
  const range = () => st.offsetHeight - pin.offsetHeight;
  function mode() {
    st.style.setProperty('--hdr', hdrH() + 'px'); document.documentElement.style.setProperty('--hdr-h', hdrH() + 'px');
    live = !rmq.matches && !shortq.matches;
    st.classList.toggle('live', live);
    if (!live) { panels.forEach(el => { el.style.opacity = ''; el.style.transform = ''; }); st.style.backgroundColor = ''; }
    paint();
  }
  function paint() {
    raf = 0; if (!live) return;
    const r = range(), p = r > 0 ? clamp((hdrH() - st.getBoundingClientRect().top) / r, 0, 1) : 0;
    panels.forEach((el, i) => {
      const [a, b, c, d] = WIN[i];
      const vin = a < 0 ? 1 : sm((p - a) / (b - a)), vout = d > 1 ? 1 : 1 - sm((p - c) / (d - c));
      el.style.opacity = Math.min(vin, vout).toFixed(3);
      el.style.transform = `translate3d(0,${((1 - vin) * 26 - (1 - vout) * 26).toFixed(1)}px,0)`;
    });
    const k = sm((p - .26) / .15);
    st.style.backgroundColor = `rgb(${SAND.map((v, j) => Math.round(v + (CHALK[j] - v) * k)).join(',')})`;
  }
  addEventListener('scroll', () => { if (live && !raf) raf = requestAnimationFrame(paint); }, { passive: true });
  addEventListener('resize', mode);
  [rmq, shortq].forEach(q => q.addEventListener ? q.addEventListener('change', mode) : q.addListener(mode));
  mode();
  storyTo = (i, smooth = true) => {
    const at = [.12, .505, .88][i];
    const y = live ? top() - hdrH() + range() * at : top() - hdrH() + (i ? panels[i].offsetTop - 40 : 0);
    scrollTo({ top: Math.max(0, y), behavior: smooth && !RM ? 'smooth' : 'auto' });
  };
})();

/* ---------- ritual iii: a few drops of oil. The film plays through once each time the step comes into view,
   and rests on its last frame; with reduced motion the still says it ---------- */
(() => {
  const box = $('#oilFilm'); if (!box || RM) return;
  const v = $('video', box);
  v.addEventListener('playing', () => v.classList.add('on'));
  new IntersectionObserver(es => es.forEach(e => {
    if (e.intersectionRatio >= .6) {
      if (!v.getAttribute('src')) { v.preload = 'auto'; v.src = NAC.media.oil; }
      if (v.paused) { if (v.ended || v.dataset.left) { v.currentTime = 0; delete v.dataset.left; } v.play().catch(() => {}); }
    } else if (!e.isIntersecting) { if (!v.paused) v.pause(); v.dataset.left = '1'; }
  }), { threshold: [0, .6] }).observe(box);
})();

/* ---------- the evening flame, drawn live: a real flame is never still, and neither is the light it throws.
   The picture's own flame is covered by the same scene rendered without it (.unlit); the flame is drawn here; and the
   light it casts on the glass, the stone and the wall, shadows and all, is a second render with the flame brighter
   (.glow), shown more or less as the flame breathes. Nothing here touches the tube. ---------- */
(() => {
  const cv = $('#fire'); if (!cv || !cv.getContext) return;
  const sec = cv.closest('.moment'), cover = cv.parentElement, ctx = cv.getContext('2d');
  const glows = $$('.glow', cover);
  let tx0 = 0, ty0 = 0, tx1 = 0, ty1 = 0;
  const rm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let W = 0, H = 0, dpr = 1, bx = 0, by = 0, fh = 0, run = false, t0 = performance.now();
  // three incommensurate waves plus a slow wandering draught: the flicker never repeats
  const wave = (t, a, b, c) => Math.sin(t * a) * 0.5 + Math.sin(t * b + 1.7) * 0.3 + Math.sin(t * c + 0.4) * 0.2;
  let gust = 0, gustT = 0, gustV = 0;
  function size() {
    const r = cover.getBoundingClientRect(); if (!r.width) return;
    dpr = Math.min(2, devicePixelRatio || 1); W = r.width; H = r.height;
    cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    const [x, y, h] = (innerWidth <= 900 ? cv.dataset.m : cv.dataset.d).split(',').map(Number);
    bx = W * x; by = H * y; fh = H * h;
    const [a, b, c, d] = (innerWidth <= 900 ? cv.dataset.tm : cv.dataset.td).split(',').map(Number);
    tx0 = W * a; ty0 = H * b; tx1 = W * c; ty1 = H * d;
  }
  function flame(cx, base, h, w, lean, alpha, core) {
    ctx.beginPath();
    // narrow at the wick, fullest a third of the way up, drawn to a soft tip that leans with the draught
    ctx.moveTo(cx - w * 0.22, base);
    ctx.bezierCurveTo(cx - w * 0.62, base - h * 0.18, cx - w * 0.50 + lean * 0.35, base - h * 0.62, cx + lean, base - h);
    ctx.bezierCurveTo(cx + w * 0.50 + lean * 0.35, base - h * 0.62, cx + w * 0.62, base - h * 0.18, cx + w * 0.22, base);
    ctx.closePath();
    const g = ctx.createLinearGradient(0, base, 0, base - h);
    if (core) { g.addColorStop(0, `rgba(255,255,255,0)`); g.addColorStop(0.25, `rgba(255,252,240,${0.85 * alpha})`); g.addColorStop(0.7, `rgba(255,246,210,${0.95 * alpha})`); g.addColorStop(1, `rgba(255,238,190,0)`); }
    else { g.addColorStop(0, `rgba(60,90,230,${0.12 * alpha})`); g.addColorStop(0.07, `rgba(90,120,255,${0.5 * alpha})`); g.addColorStop(0.16, `rgba(255,110,20,${0.8 * alpha})`); g.addColorStop(0.42, `rgba(255,185,60,${alpha})`); g.addColorStop(0.72, `rgba(255,232,165,${alpha})`); g.addColorStop(1, `rgba(255,250,235,${0.4 * alpha})`); }
    ctx.fillStyle = g; ctx.fill();
  }
  function draw(now) {
    if (!W) size(); if (!W) return;
    const t = (now - t0) / 1000;
    // a draught: every few seconds the flame leans and stretches, then settles
    if (t > gustT) { gustT = t + 2 + Math.random() * 5; gustV = (Math.random() - 0.5) * 2; }
    gust += (gustV - gust) * 0.02; gustV *= 0.995;
    const n1 = wave(t, 9.1, 13.7, 21.3), n2 = wave(t, 7.3, 11.9, 17.1), n3 = wave(t, 3.1, 5.3, 8.7);
    const br = 1 + 0.10 * n1;                                  // brightness
    const h = fh * (1 + 0.14 * n2 + 0.08 * Math.abs(gust));   // height
    const w = h * 0.46 * (1 - 0.05 * n2);
    const lean = w * (0.35 * n3 + 0.9 * gust);
    // the room: the light on the glass, the stone and the wall (and the shadows in it) rises and falls with the flame
    const k = clamp(0.45 + 2.5 * (br - 1) - 0.2 * Math.abs(gust), 0.1, 0.95).toFixed(3);
    glows.forEach(g => { g.style.opacity = k; });
    ctx.clearRect(0, 0, W, H);
    // the halo close to the flame
    ctx.globalCompositeOperation = 'lighter';
    let g = ctx.createRadialGradient(bx + lean * 0.3, by - h * 0.45, 0, bx + lean * 0.3, by - h * 0.45, h * 1.7);
    g.addColorStop(0, `rgba(255,170,80,${0.5 * br})`); g.addColorStop(0.35, `rgba(255,130,50,${0.2 * br})`); g.addColorStop(1, 'rgba(255,100,30,0)');
    ctx.fillStyle = g; ctx.fillRect(bx - h * 2, by - h * 2.3, h * 4, h * 3.4);
    // the flame: bloom, body, core
    ctx.shadowColor = 'rgba(255,160,50,0.9)'; ctx.shadowBlur = h * 0.45 * dpr;
    flame(bx, by, h, w, lean, 0.92 * br, false);
    ctx.shadowBlur = h * 0.18 * dpr; ctx.shadowColor = 'rgba(255,240,200,0.9)';
    flame(bx + lean * 0.15, by - h * 0.06, h * 0.66, w * 0.46, lean * 0.7, br, true);
    ctx.shadowBlur = 0; ctx.globalCompositeOperation = 'source-over';
    // the tube is shown exactly as it is made: nothing drawn here reaches it (soft-edged, so no line shows)
    const tw = tx1 - tx0, th = ty1 - ty0, bl = Math.max(4, tw * 0.05), e = bl * 0.6;
    ctx.save(); ctx.globalCompositeOperation = 'destination-out'; ctx.shadowColor = '#000'; ctx.shadowBlur = bl * dpr; ctx.shadowOffsetX = 5000 * dpr;
    ctx.fillStyle = '#000'; ctx.fillRect(tx0 - e - 5000, ty0 - e, tw + 2 * e, th + 2 * e); ctx.restore();
    if (run && !rm) requestAnimationFrame(draw);
  }
  const start = () => { if (run) return; run = true; size(); sec.classList.add('live'); requestAnimationFrame(draw); };
  const stop = () => { run = false; };
  if ('IntersectionObserver' in window) new IntersectionObserver(es => es.forEach(e => e.isIntersecting ? start() : stop()), { rootMargin: '200px' }).observe(sec); else start();
  addEventListener('resize', () => { W = 0; if (rm) draw(performance.now()); }, { passive: true });
  document.addEventListener('visibilitychange', () => document.hidden ? stop() : (sec.getBoundingClientRect().top < innerHeight && start()));
})();

/* ---------- boot ---------- */
if (view() === 'product') bootViewersOnce();
loadCart();
if (document.body.classList.contains('t-cart')) { const o = async () => { await loadCart(); openBag(); }; $('#cartOpen') && $('#cartOpen').addEventListener('click', o); o(); }
const start = location.hash.slice(1); if (start) setTimeout(() => go(start, false), 50);
track('page_view', { view: view() });
})();
